import jQuery from "jquery";

jQuery(function () {
  jQuery(".add-to-sales-contract-button").click(function () {
    jQuery(this).toggleClass("expanded");
    jQuery(".add-to-sales-contract").toggleClass("hidden");
  });
  jQuery(".add-to-sales-contract").addClass("hidden");
});
